import Image from 'next/image';

import { useGlobal } from '@hultafors/hultaforsgroup/hooks';

import styles from './image-placeholder.module.scss';

const ImagePlaceholder: React.FC = () => {
  const { globalContent } = useGlobal();

  if (!globalContent.navigationLogo) return null;

  return (
    <div className={styles['container']}>
      <figure className={styles['placeholder']}>
        <Image
          alt="Image placeholder"
          fill
          src={globalContent.navigationLogo.url}
        />
      </figure>
    </div>
  );
};

export default ImagePlaceholder;
